import {
  mutationOptions,
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import __ from "src/utils/Translations";
import { dynamicNotification } from "src/utils/Notifications";
import { fetchFeatureConfiguration, saveFeatureConfiguration } from "./api";
import { AbsenceQueryKeys } from "./config";

export interface IFeatureConfiguration {
  featuresConfigurations: {
    [key: string]: {
      wholeCompany: boolean;
    };
  };
}

const FeatureConfigurationQueries = {
  byCompanyId: (companyId: string) =>
    queryOptions<IFeatureConfiguration, Error>({
      enabled: !!companyId,
      queryKey: AbsenceQueryKeys.absenceConfiguration(companyId),
      queryFn: () => fetchFeatureConfiguration(companyId),
    }),

  save: (companyId: string) =>
    mutationOptions({
      mutationFn: (formData: IFeatureConfiguration) =>
        saveFeatureConfiguration(companyId, formData),
    }),
};

export const useFetchFeatureConfiguration = (companyId: string) =>
  useQuery(FeatureConfigurationQueries.byCompanyId(companyId));

export const useSaveFeatureConfiguration = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...FeatureConfigurationQueries.save(companyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: AbsenceQueryKeys.absenceConfiguration(companyId),
      });
      dynamicNotification(__("Pomyślnie zapisano konfigurację."));
    },
    onError: () => {
      dynamicNotification(
        __("Nie udało się zapisać danych."),
        "error",
        "top-right",
        7000
      );
    },
  });
};

export default FeatureConfigurationQueries;
